import ShareableLinkDocumentsHeading from './ShareableLinkDocumentsHeading.component';

export default ShareableLinkDocumentsHeading;
